import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-about-me',
  templateUrl: './about-me.component.html',
  styleUrls: ['./about-me.component.css']
})
export class AboutMeComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }


  facebookOnClick() {
    window.open("https://www.facebook.com/karteek.rakshit", "_blank");
  }
  twitterOnClick() {
    window.open("https://twitter.com/KarteekRakshit", "_blank");
  }
  githubOnClick() {
    window.open("https://github.com/KarteekRakshit", "_blank");
  }
  instagramOnClick() {
    window.open("https://www.instagram.com/karteekrakshit/", "_blank");
  }
  linkedinOnClick() {
    window.open("https://www.linkedin.com/in/karteekrakshit/", "_blank");
  }
  // emailOnClick() {
  //   //window.open("https://www.facebook.com/karteek.rakshit", "_blank");
  // }



}
